module.exports = __webpack_public_path__ + "img/reveal.ad35ed30.svg";